import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: '16px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  close: {
    top: '16px',
    right: '12px'
  }
}))

export default useStyles
